/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { IdErrorResultDtoOfString } from './IdErrorResultDtoOfString';
import {
    IdErrorResultDtoOfStringFromJSON,
    IdErrorResultDtoOfStringFromJSONTyped,
    IdErrorResultDtoOfStringToJSON,
} from './IdErrorResultDtoOfString';

/**
 * 
 * @export
 * @interface BulkActionResultDtoOfString
 */
export interface BulkActionResultDtoOfString {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkActionResultDtoOfString
     */
    itemsActionSucceeded?: Array<string> | null;
    /**
     * 
     * @type {Array<IdErrorResultDtoOfString>}
     * @memberof BulkActionResultDtoOfString
     */
    itemsActionFailed?: Array<IdErrorResultDtoOfString> | null;
    /**
     * 
     * @type {string}
     * @memberof BulkActionResultDtoOfString
     */
    $type?: BulkActionResultDtoOfStringTypeEnum;
}


/**
 * @export
 */
export const BulkActionResultDtoOfStringTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoBulkActionResultsBulkActionResultDto1SystemStringSystemPrivateCoreLibPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.BulkActionResults.BulkActionResultDto`1[[System.String, System.Private.CoreLib]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type BulkActionResultDtoOfStringTypeEnum = typeof BulkActionResultDtoOfStringTypeEnum[keyof typeof BulkActionResultDtoOfStringTypeEnum];



/**
 * Check if a given object implements the BulkActionResultDtoOfString interface.
 */
export function instanceOfBulkActionResultDtoOfString(value?: unknown): value is BulkActionResultDtoOfString {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BulkActionResultDtoOfStringTypeEnum)[0];
}

export function BulkActionResultDtoOfStringFromJSON(json: any): BulkActionResultDtoOfString {
    return BulkActionResultDtoOfStringFromJSONTyped(json, false);
}

export function BulkActionResultDtoOfStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkActionResultDtoOfString {
    if (json == null) {
        return json;
    }
    return {
        
        'itemsActionSucceeded': json['itemsActionSucceeded'] == null ? undefined : json['itemsActionSucceeded'],
        'itemsActionFailed': json['itemsActionFailed'] == null ? undefined : ((json['itemsActionFailed'] as Array<any>).map(IdErrorResultDtoOfStringFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BulkActionResultDtoOfStringToJSON(value?: BulkActionResultDtoOfString | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'itemsActionSucceeded': value['itemsActionSucceeded'],
        'itemsActionFailed': value['itemsActionFailed'] == null ? undefined : ((value['itemsActionFailed'] as Array<any>).map(IdErrorResultDtoOfStringToJSON)),
        '$type': value['$type'],
    });
}

